import { type FC } from 'react';
import { CloseCircleOutlined, SendOutlined } from '@ant-design/icons';
import { Space, Button } from '@g2u/ui-kit';
import { Spin } from 'antd';

import { type WithOptionalDataTest } from 'types';

type Props = {
  step?: number;
  onOk?: () => void;
  onCancel?: () => void;
  onSkip?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
} & WithOptionalDataTest;

export const CloseCallbackActions: FC<Props> = (props) => {
  const { step, onOk, onCancel, onSkip, isLoading, isDisabled } = props;
  if (step === undefined || isNaN(step)) return <Spin />;

  const commentStep = step === 0;
  const voiceMessageStep = step === 1;
  const emailStep = step === 2;
  const smsStep = step === 3;

  return (
    <Space.$ size={Space.Size.Middle} justify={Space.Justify.End}>
      {(commentStep || voiceMessageStep) && (
        <Button.$ onClick={onCancel} disabled={isLoading} dataTestId="cancel-btn">
          Cancel
        </Button.$>
      )}

      {(emailStep || smsStep) && (
        <Button.$ onClick={onSkip} danger disabled={isLoading} dataTestId="skip-btn">
          <CloseCircleOutlined /> Skip Sending {emailStep ? 'Email' : 'SMS'}
        </Button.$>
      )}

      <Button.$ type={Button.Type.Primary} onClick={onOk} loading={isLoading} disabled={isDisabled} dataTestId="ok-btn">
        {commentStep && 'Save and close the callback'}
        {voiceMessageStep && 'I have left the customer a voice message'}
        {(emailStep || smsStep) && (
          <>
            <SendOutlined /> {emailStep ? 'Send Email' : 'Send SMS'}
          </>
        )}
      </Button.$>
    </Space.$>
  );
};
